import { gql } from '@src/__generated__';

export const GET_ATTRACTIONS_BY_IDS = gql(`
  query AttractionsByIds($ids: [ID!]!) {
    attractionByIds(ids: $ids) {
      id
      slug
      nameLatin
      nameDisplay
      googlePlaceId
    }
  }
`);
